import { computed } from 'vue'

// Режимы UI-формы договора:
// - create  — у заявления ещё нет договора
// - editable — договор есть, не отправлен или провален отправкой, в 1С не зарегистрирован
// - pending  — договор сейчас отправляется или уже отправлен (форма disabled)
// - approved — договор зарегистрирован в 1С, показывается номер/дата/способы оплаты

export function useContractMode(contract) {
  const mode = computed(() => {
    if (!contract.value) return 'create'
    if (contract.value.has_approval) return 'approved'
    if (['being_sent', 'sent'].includes(contract.value.mailing_status)) return 'pending'
    return 'editable'
  })

  const isEditable = computed(() => mode.value === 'create' || mode.value === 'editable')

  const canSend = computed(() =>
    contract.value &&
    !contract.value.has_approval &&
    ['not_sent', 'failed'].includes(contract.value.mailing_status)
  )

  return { mode, isEditable, canSend }
}
